export default __webpack_public_path__ + "static/media/CloverFlex0.e684421f.jpg";